import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Collapse, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, TabContent, TabPane } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
import ReactApexChart from "react-apexcharts";
import ExportDoc from "../../../Components/Common/ExportDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import FormData from "form-data";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getVillage, resetVillageState } from "../../../store/village/action";
import { getAgency, resetAgencyState } from "../../../store/agency/action";
import { deleteFile } from "../../../store/file/action";
import { getBank } from "../../../store/bank/action";
import { resetUserState, getUser } from "../../../store/users/action";
import { resetCustomerState, getCustomer as onGetCustomers } from "../../../store/customer/action";
import { resetAgentState, getAgent as onGetAgents, addNewAgent as onAddNewAgent, updateAgent as onUpdateAgent, deleteAgent as onDeleteAgent, getAgentLoading } from "../../../store/agent/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logo from "../../../assets/images/users/user-dummy-img.jpg";

import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";

const Agent = (props) => {
  const [placeDefaultVal, setPlaceDefaultVal] = useState("");
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [subTab, setSubTab] = useState("ringkasan");
  const [rankInd, setRankInd] = useState("booking");
  const [rankTb, setRankTb] = useState("top");
  const [rankLvl, setRankLvl] = useState("all");
  const [bulanMonth, setBulanMonth] = useState("");
  const [bulanInd, setBulanInd] = useState("booking");
  const [bulanTb, setBulanTb] = useState("top");
  const [bulanMode, setBulanMode] = useState("angka");
  const [convKey, setConvKey] = useState("bk2be");
  const [convTb, setConvTb] = useState("top");
  const [raporMid, setRaporMid] = useState("");
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [modalMedia, setModalMedia] = useState(false);
  const [otherDocImg, setOtherDocImg] = useState([]);
  const [branch, setBranch] = useState(null);
  const [marketing, setMarketing] = useState(null);
  const [partner, setPartner] = useState(null);
  const [salesTarget, setSalesTarget] = useState(8000);
  const [minBook, setMinBook] = useState(5);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, agents, isAgentCreated, isAgentSuccess, loading, error, agencys, agencysLoading, villages, villageLoading, companies, companyLoading, clients, clientLoading, banks, bankLoading, users, usersLoading, branches, branchLoading, customers, customerLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    agents: state.Agent.agents,
    isAgentCreated: state.Agent.isAgentCreated,
    isAgentSuccess: state.Agent.isAgentSuccess,
    loading: state.Agent.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    banks: state.Bank.banks,
    bankLoading: state.Bank.loading,
    villages: state.Village.villages,
    villageLoading: state.Village.loading,
    error: state.Agent.error,
    agencys: state.Agency.agencys,
    agencysLoading: state.Agency.loading,
    users: state.Users.users,
    usersLoading: state.Users.loading,
    customers: state.Customer.customers,
    customerLoading: state.Customer.loading,
  }));

  const [agentList, setAgentList] = useState([]);
  const [agencyList, setAgencyList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [agent, setAgent] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [agentContactItem, setAgentContactItem] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [bankList, setBankList] = useState([]);
  const [expense, setExpense] = useState([]);
  const [salesDoc, setSalesDoc] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [branchList, setBranchList] = useState([]);

  const expanseDataRef = useRef([]);
  const [open, setOpen] = useState("1");
  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen(open);
    } else {
      setOpen(id);
    }
  };

  useEffect(() => {
    let dataDoc = [
      {
        id: "sales",
        label: "Salesman",
        isSelected: true,
        data: [],
      },
      {
        id: "agency",
        label: "Mitra",
        isSelected: true,
        data: [],
      },
      {
        id: "booking",
        label: "Booking",
        isSelected: true,
        data: [],
      },
      {
        id: "cash",
        label: "Cash",
        isSelected: true,
        data: [],
      },
      {
        id: "kantor",
        label: "Kantor",
        isSelected: true,
        data: [],
      },
      {
        id: "bank",
        label: "Bank",
        isSelected: true,
        data: [],
      },
      {
        id: "sp3k",
        label: "SP3K",
        isSelected: true,
        data: [],
      },
      {
        id: "akad",
        label: "Akad",
        isSelected: true,
        data: [],
      },
      {
        id: "cancel",
        label: "Canceled",
        isSelected: true,
        data: [],
      },
      {
        id: "target",
        label: "Target",
        isSelected: true,
        data: [],
      },
    ];

    if (agentList.length > 0) {
      let startat = "";
      let endat = "";
      let datearr = filterDate?.split(" to ");
      if (datearr) {
        startat = datearr[0];
        endat = datearr[1] ? datearr[1] : datearr[0];
      }
      if (!datearr) {
        agentList
          .filter(f => partner && partner.value ? f?.agencyId === partner.value : true)
          .forEach((sales) => {
            let first = true;
            let doc = dataDoc.find((d) => d.id === "sales");
            if (doc) doc.data.push(sales.name);

            doc = dataDoc.find((d) => d.id === "agency");
            if (doc) doc.data.push(sales?.agency_agent?.name);

            doc = dataDoc.find((d) => d.id === "booking");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => sales.transactionat !== null && (branch && branch.value ? sales?.branchId === branch.value : true)).length);

            doc = dataDoc.find((d) => d.id === "cash");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => (sales.typeId === 3 || sales.typeId === 4) && (branch && branch.value ? sales?.branchId === branch.value : true)).length);

            doc = dataDoc.find((d) => d.id === "kantor");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.docat !== null && (branch && branch.value ? sales?.branchId === branch.value : true)).length);

            doc = dataDoc.find((d) => d.id === "bank");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.bankat !== null && (branch && branch.value ? sales?.branchId === branch.value : true)).length);

            doc = dataDoc.find((d) => d.id === "sp3k");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.sp3at !== null && (branch && branch.value ? sales?.branchId === branch.value : true)).length);

            doc = dataDoc.find((d) => d.id === "akad");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.completedat !== null && (branch && branch.value ? sales?.branchId === branch.value : true)).length);

            doc = dataDoc.find((d) => d.id === "cancel");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => sales.statusId === 6 && (branch && branch.value ? sales?.branchId === branch.value : true)).length);

          });
      }
      else {
        agentList
          .filter(f => partner && partner.value ? f?.agencyId === partner.value : true)
          .forEach((sales) => {
            let first = true;
            let doc = dataDoc.find((d) => d.id === "sales");
            if (doc) doc.data.push(sales.name);

            doc = dataDoc.find((d) => d.id === "agency");
            if (doc) doc.data.push(sales?.agency_agent?.name);

            doc = dataDoc.find((d) => d.id === "booking");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => sales.transactionat !== null && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length);

            doc = dataDoc.find((d) => d.id === "cash");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => (sales.typeId === 3 || sales.typeId === 4) && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length);

            doc = dataDoc.find((d) => d.id === "kantor");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.docat !== null && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length);

            doc = dataDoc.find((d) => d.id === "bank");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.bankat !== null && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length);

            doc = dataDoc.find((d) => d.id === "sp3k");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.sp3at !== null && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length);

            doc = dataDoc.find((d) => d.id === "akad");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.completedat !== null && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length);

            doc = dataDoc.find((d) => d.id === "cancel");
            if (doc) doc.data.push((sales.agent_sales || []).filter((sales) => sales.statusId === 6 && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length);

          });
      }
    }

    setSalesDoc(dataDoc);
  }, [agentList, filterDate, branch, partner, salesTarget]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const onClickDelete = (agent) => {
    setAgent(agent);
    setDeleteModal(true);
  };

  const onClickApprove = (agent) => {
    setAgent(agent);
    setApproveModal(true);
  };

  const handleDeleteAgent = () => {
    if (agent) {
      dispatch(onDeleteAgent(agent));
      setDeleteModal(false);
    }
  };

  const handleApproveAgent = () => {
    if (agent) {
      agent.setApprove = true;
      dispatch(onUpdateAgent(agent));
      setApproveModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    dispatch(resetAgentState());
    dispatch(onGetAgents());
    dispatch(onGetCustomers());
    handleGetGroup(userData?.companyId);
  }, []);

  useEffect(() => {
    if (!isEmpty(agents)) {
      let filteredAgents = agents;
      if (activeTypeTab !== "all") {
        filteredAgents = agents.filter((agent) => agent.agent_status.name === activeTypeTab);
      }
      setAgentList(filteredAgents.map((el) => ({ ...el, isChecked: false })));
      setInfo(agents[agents.length - 1]);
      setIsEdit(false);
    }
  }, [agents]);

  useEffect(() => {
    if (!isEmpty(users)) {
      var data = [];
      var opt = [];
      users.forEach((item, key) => {
        const name = item.name;
        const phone = item.phone;
        const email = item.email;
        const id = item.id;
        var obj = { label: name, value: id, phone: phone, email: email };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setUserList(data);
    }
  }, [users]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [{ label: "SEMUA CABANG/PROYEK", value: null, companyId: companySelected.value }];
      branches.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    var data = [];
    var opt = [{ label: "SEMUA MITRA", value: null, companyId: companySelected.value }];
    agencys.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);
    setAgencyList(data);
  }, [agencys]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  useEffect(() => {
    if (!isEmpty(villages)) {
      var villageData = [];
      var opt = [];
      villages.forEach((item, key) => {
        const village_name = item.village_name;
        const id = item.id;
        const city_name = item.vc.city_name;
        const district_name = item.vd.district_name;
        const province_name = item.vp.province_name;
        var obj = { label: village_name + ", " + district_name + ", " + city_name + " - " + province_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      villageData.push(option);
      setVillageList(villageData);
    }
  }, [villages]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
    }
  };

  useEffect(() => {
    if (!isEmpty(banks)) {
      var data = [];
      var opt = [];
      banks.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankList(data);
    }
  }, [banks]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAgent(null);
      setAgentContactItem([]);
      setPlaceDefaultVal("");
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleGetCompany = useCallback(
    (id) => {
      dispatch(resetCompanyState());
      dispatch(getCompany({ clientId: id }));
    },
    [dispatch],
  );

  const handleGetGroup = useCallback(
    (companyId) => {
      dispatch(resetCompanyState());
      dispatch(getAgency({ companyId: companyId }));
    },
    [dispatch],
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = agentList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAgentList(updated);
    setIsCheckAll(allChecked);
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetAgents(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAgentList([]);
    setStatusActive([]);
    dispatch(resetAgentState());
    dispatch(onGetAgents());
  };

  function isDateBetween(dateToCheckString, startDateString, endDateString) {
    const dateToCheck = new Date(dateToCheckString);
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    if (isNaN(dateToCheck.getTime()) || isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error("Invalid date format provided.");
      return false;
    }

    return dateToCheck >= startDate && dateToCheck <= endDate;
  }

  function isDateUnder(dateToCheckString, startDateString) {
    const dateToCheck = new Date(dateToCheckString);
    const startDate = new Date(startDateString);

    if (isNaN(dateToCheck.getTime()) || isNaN(startDate.getTime())) {
      console.error("Invalid date format provided.");
      return false;
    }

    return dateToCheck <= startDate;
  }

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return (
          (el?.sales_customer?.name ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.transaction_no ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el?.sales_branch?.name ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.description ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (handleValidDate(el.transactionat) ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (handleValidDate(el.docat) ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1
        );
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteAgent(element.value));
    });
    checkall.checked = false;
  };

  const PCT_UP = [[75, "A"], [50, "B"], [25, "C"], [0, "D"]];
  const PCT_DN = [[75, "D"], [50, "C"], [25, "B"], [0, "A"]];
  const STD = {
    booking: { label: "Jumlah Booking", kind: "count", good: "up", bands: [[25, "A"], [14, "B"], [5, "C"], [0, "D"]] },
    belum: { label: "Berkas Belum", kind: "pct", good: "down", num: "blm", den: "booking", bands: PCT_DN },
    berkas: { label: "Berkas Lengkap", kind: "pct", good: "up", num: "be", den: "booking", bands: PCT_UP },
    akad: { label: "Jumlah Akad", kind: "pct", good: "up", num: "ak", den: "be", bands: PCT_UP },
    cash: { label: "Jumlah Cash", kind: "count", good: "up", bands: [[3, "A"], [2, "B"], [1, "C"], [0, "D"]] },
    reject: { label: "Jumlah Reject", kind: "pct", good: "down", num: "rj", den: "be", bands: PCT_DN },
    cancel: { label: "Jumlah Cancel", kind: "pct", good: "down", num: "cn", den: "booking", bands: PCT_DN },
  };
  const CONV = {
    bk2be: { label: "Booking → Berkas Lengkap", dir: "up", bands: PCT_UP, num: "be", den: "booking" },
    be2ak: { label: "Berkas → Akad", dir: "up", bands: PCT_UP, num: "ak", den: "be" },
    bk2ak: { label: "Booking → Akad", dir: "up", bands: PCT_UP, num: "ak", den: "booking" },
    loss: { label: "Booking → Reject/Cancel", dir: "down", bands: PCT_DN, num: "loss", den: "booking" },
  };
  const HOLIDAYS = {
    "2025-01-01": "Tahun Baru", "2025-01-27": "Isra Mikraj", "2025-01-29": "Imlek 2576",
    "2025-03-29": "Nyepi", "2025-03-31": "Idul Fitri", "2025-04-01": "Idul Fitri",
    "2025-04-18": "Wafat Isa Almasih", "2025-04-20": "Paskah", "2025-05-01": "Hari Buruh",
    "2025-05-12": "Waisak", "2025-05-29": "Kenaikan Isa Almasih", "2025-06-01": "Hari Lahir Pancasila",
    "2025-06-06": "Idul Adha", "2025-06-27": "Tahun Baru Islam 1447 H", "2025-08-17": "Kemerdekaan RI",
    "2025-09-05": "Maulid Nabi", "2025-12-25": "Natal",
    "2026-01-01": "Tahun Baru", "2026-01-16": "Isra Mikraj", "2026-02-17": "Imlek 2577",
    "2026-03-19": "Nyepi", "2026-03-21": "Idul Fitri", "2026-03-22": "Idul Fitri",
    "2026-04-03": "Wafat Isa Almasih", "2026-04-05": "Paskah", "2026-05-01": "Hari Buruh",
    "2026-05-14": "Kenaikan Isa Almasih", "2026-05-27": "Idul Adha", "2026-05-31": "Waisak 2570",
    "2026-06-01": "Hari Lahir Pancasila", "2026-06-16": "Tahun Baru Islam 1448 H", "2026-08-17": "Kemerdekaan RI",
    "2026-08-25": "Maulid Nabi", "2026-12-25": "Natal"
  };
  const LEVELS = [
    { key: "platinum", min: 20, label: "Platinum", icon: "ri-vip-diamond-line", range: "≥ 20" },
    { key: "gold", min: 15, label: "Gold", icon: "ri-medal-line", range: "15 – 19" },
    { key: "silver", min: 10, label: "Silver", icon: "ri-medal-line", range: "10 – 14" },
    { key: "bronze", min: 5, label: "Bronze", icon: "ri-medal-line", range: "5 – 9" },
    { key: "none", min: 0, label: "No Level", icon: "ri-checkbox-blank-circle-line", range: "≤ 4" },
  ];
  const gradeVal = (cfg, v) => { for (const [t, g] of cfg.bands) { if (v >= t) return g; } return "D"; };
  const gradeSLA = (pct) => pct >= 60 ? "A" : pct >= 45 ? "B" : pct >= 30 ? "C" : "D";
  const levelOf = (bk) => { for (const L of LEVELS) { if (bk >= L.min) return L; } return LEVELS[LEVELS.length - 1]; };
  const levelBadge = (bk) => { const L = levelOf(bk); return `<span class="badge bg-${L.key === "platinum" ? "dark" : L.key === "gold" ? "warning" : L.key === "silver" ? "secondary" : L.key === "bronze" ? "orange" : "light"} text-${L.key === "none" ? "muted" : "white"}">${L.label}</span>`; };
  const gradeColor = (g) => g === "A" ? "success" : g === "B" ? "info" : g === "C" ? "warning" : "danger";
  const indVal = (a, ind) => {
    const c = STD[ind];
    if (c.kind === "count") { const v = ind === "booking" ? a.booking : a.ch; return { v, disp: String(v), grade: gradeVal(c, v) }; }
    const num = c.num === "blm" ? (a.blm || 0) : a[c.num];
    const den = a[c.den] || 0;
    const v = den ? Math.round(num / den * 100) : 0;
    return { v, disp: v + "%", num, den, grade: gradeVal(c, v) };
  };

  document.title = "Analisa Penjualan | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={agentList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAgent} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={agent && agent.name ? agent.name : ""} show={approveModal} onApproveClick={handleApproveAgent} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Penjualan" pageTitle="Analisa Penjualan" loading={loading}>
          <div className="flex-shrink-0">
            <ExportDoc data={salesDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success mb-3 fs-14" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-funds-box-line  me-1 align-bottom fs-16"></i>TARGET PENJUALAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-slideshow-line me-1 align-bottom fs-16"></i>PERFORMA PENJUALAN
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem> */}
                  </Nav>
                  <div className="border border-top-0 border-end-0 border-start-0 mb-3 pb-3 pt-3">
                    <Row className="align-items-center">

                      <Col sm={3}>
                        <div className="mb-2">
                          <label className="form-label fw-semibold">Salesman</label>
                          <div className="search-box me-2 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setMarketing(e.target.value);
                              }}
                              placeholder={`${agentList.length} Cari...`}
                              value={marketing ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </Col>
                      <Col sm={3}>
                        <div className="mb-2">
                          <label className="form-label fw-semibold">Cabang/Proyek</label>
                          <Select
                            name="branch"
                            placeholder="Pilih Cabang/Proyek"
                            value={branch}
                            onChange={(e) => {
                              setBranch(e);
                            }}
                            options={branchList}
                          ></Select>
                        </div>
                      </Col>
                      <Col sm={2}>
                        <div className="mb-2">
                          <label className="form-label fw-semibold">Mitra</label>
                          <Select
                            name="agency"
                            value={partner}
                            placeholder="Pilih Mitra"
                            onChange={(e) => {
                              setPartner(e);
                            }}
                            options={agencyList}
                          ></Select>
                        </div>
                      </Col>
                      <Col sm={2}>
                        <div className="mb-2">
                          <label className="form-label fw-semibold">Tanggal</label>
                          <div className="search-box">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </div>
                      </Col>

                      <Col sm={1}>
                        <div className="mb-2">
                          <label className="form-label fw-semibold">Target</label>
                          <Input value={salesTarget} onFocus={e => e.target.select()} className="form-control" placeholder="1" type="number" onChange={(e) => {
                            setSalesTarget(e.target.value);
                          }} />
                        </div>
                      </Col>

                      <Col sm={1}>
                        <div className="mb-2">
                          <label className="form-label fw-semibold">Min Book</label>
                          <Input value={minBook} onFocus={e => e.target.select()} className="form-control" placeholder="1" type="number" onChange={(e) => {
                            setMinBook(e.target.value);
                          }} />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <div className="table-responsive table-card mb-1">
                        <Table hover className="align-middle table-hover table-nowrap">
                          <thead className="table-light">
                            <tr>
                              {/* <th><input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} /></th> */}
                              <th>NAMA SALES</th>
                              <th>BOOKING</th>
                              <th>CASH</th>
                              <th>KANTOR</th>
                              <th>BANK</th>
                              <th>SP3K</th>
                              <th>AKAD</th>
                              <th>CANCEL</th>
                              <th>%TARGET</th>
                            </tr>
                          </thead>
                          <tbody >
                            {(agentList || [])
                              .filter(f => (partner && partner.value ? f?.agencyId === partner.value : true) && (marketing ? (f?.name ?? "").toLowerCase().indexOf(marketing.toLowerCase()) !== -1 : true))
                              .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }))
                              .map((row, idx) => {
                                let startat = "";
                                let endat = "";
                                let datearr = filterDate?.split(" to ");
                                if (datearr) {
                                  startat = datearr[0];
                                  endat = datearr[1] ? datearr[1] : datearr[0];
                                }
                                if (!datearr) {
                                  let sBook = (row.agent_sales || []).filter((sales) => sales.transactionat !== null && (branch && branch.value ? sales?.branchId === branch.value : true)).length;
                                  let sCash = (row.agent_sales || []).filter((sales) => (sales.typeId === 3 || sales.typeId === 4) && (branch && branch.value ? sales?.branchId === branch.value : true)).length;
                                  let sKantor = (row.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.docat !== null && (branch && branch.value ? sales?.branchId === branch.value : true)).length;
                                  let sBank = (row.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.bankat !== null && (branch && branch.value ? sales?.branchId === branch.value : true)).length;
                                  let sSp3k = (row.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.sp3at !== null && (branch && branch.value ? sales?.branchId === branch.value : true)).length;
                                  let sAkad = (row.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.completedat !== null && (branch && branch.value ? sales?.branchId === branch.value : true)).length;
                                  let sCancel = (row.agent_sales || []).filter((sales) => sales.statusId === 6 && (branch && branch.value ? sales?.branchId === branch.value : true)).length;
                                  let sTarget = ((sCash + sAkad) / salesTarget * 100).toFixed(2);
                                  return (
                                    <Fragment key={idx}>
                                      <tr onClick={() => {
                                        setInfo(row);
                                        setExpense(row.agent_sales || []);
                                        expanseDataRef.current = row.agent_sales || [];
                                        toggle();
                                      }} className="cursor-pointer">
                                        {/* <td>
                                    <div className="hstack gap-2 mt-4 mt-sm-0">
                                      <input
                                        type="checkbox"
                                        className="dataCheckbox me-2 form-check-input"
                                        checked={row.isChecked}
                                        onChange={() => {
                                          const updatedData = agentList.map((d) => (d.id === row.id ? { ...d, isChecked: !d.isChecked } : d));
                                          setAgentList(updatedData);
                                        }} />
                                    </div>
                                  </td> */}
                                        <td className="fw-semibold">{row.name} {row?.agency_agent?.name}</td>
                                        <td className={sBook > 0 ? "fw-semibold fs-14" : "text-muted"}>{sBook}</td>
                                        <td className={sCash > 0 ? "fw-semibold fs-14" : "text-muted"}>{sCash}</td>
                                        <td className={sKantor > 0 ? "fw-semibold fs-14" : "text-muted"}>{sKantor}</td>
                                        <td className={sBank > 0 ? "fw-semibold fs-14" : "text-muted"}>{sBank}</td>
                                        <td className={sSp3k > 0 ? "fw-semibold fs-14" : "text-muted"}>{sSp3k}</td>
                                        <td className={sAkad > 0 ? "fw-semibold fs-14" : "text-muted"}>{sAkad}</td>
                                        <td className={sCancel > 0 ? "fw-semibold fs-14" : "text-muted"}>{sCancel}</td>
                                        <td className={sTarget > 0 ? "fw-semibold text-success fs-14" : "fw-semibold text-danger"}>{sTarget}%</td>
                                      </tr>
                                    </Fragment>
                                  );
                                }
                                else {
                                  let sBook = (row.agent_sales || []).filter((sales) => sales.transactionat !== null && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length;
                                  let sCash = (row.agent_sales || []).filter((sales) => (sales.typeId === 3 || sales.typeId === 4) && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length;
                                  let sKantor = (row.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.docat !== null && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length;
                                  let sBank = (row.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.bankat !== null && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length;
                                  let sSp3k = (row.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.sp3at !== null && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length;
                                  let sAkad = (row.agent_sales || []).filter((sales) => (sales.typeId === 1 || sales.typeId === 2) && sales.completedat !== null && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length;
                                  let sCancel = (row.agent_sales || []).filter((sales) => sales.statusId === 6 && (branch && branch.value ? sales?.branchId === branch.value : true) && isDateBetween(handleValidDate(sales?.transactionat, "YYYY/MM/DD"), startat, endat)).length;
                                  let sTarget = ((sCash + sAkad) / salesTarget * 100).toFixed(2);
                                  return (
                                    <Fragment key={idx}>
                                      <tr onClick={() => {
                                        setInfo(row);
                                        setExpense(row.agent_sales || []);
                                        expanseDataRef.current = row.agent_sales || [];
                                        toggle();
                                      }} className="cursor-pointer fw-semibold">
                                        <td className="fw-semibold">{row.name} {row?.agency_agent?.name}</td>
                                        <td className={sBook > 0 ? "fw-semibold fs-14" : "text-muted"}>{sBook}</td>
                                        <td className={sCash > 0 ? "fw-semibold fs-14" : "text-muted"}>{sCash}</td>
                                        <td className={sKantor > 0 ? "fw-semibold fs-14" : "text-muted"}>{sKantor}</td>
                                        <td className={sBank > 0 ? "fw-semibold fs-14" : "text-muted"}>{sBank}</td>
                                        <td className={sSp3k > 0 ? "fw-semibold fs-14" : "text-muted"}>{sSp3k}</td>
                                        <td className={sAkad > 0 ? "fw-semibold fs-14" : "text-muted"}>{sAkad}</td>
                                        <td className={sCancel > 0 ? "fw-semibold fs-14" : "text-muted"}>{sCancel}</td>
                                        <td className={sTarget > 0 ? "fw-semibold text-success fs-14" : "fw-semibold text-danger"}>{sTarget}%</td>
                                      </tr>
                                    </Fragment>
                                  );
                                }
                              })}
                          </tbody>
                        </Table>
                        {loading &&
                          <div className="text-center text-muted py-5">
                            <h5>Memuat data...</h5>
                          </div>

                        }
                      </div>
                    </TabPane>
                    <TabPane tabId="2">
                      {(() => {
                        const isTabLoading = loading || agentList.length === 0 || customerLoading;
                        if (isTabLoading) {
                          return (
                            <div className="text-center text-muted py-5">
                              <h5>Memuat data...</h5>
                            </div>
                          );
                        }

                        let t2Start = "", t2End = "";
                        const arr = filterDate?.split(" to ");
                        if (arr) { t2Start = arr[0]; t2End = arr[1] || arr[0]; }
                        const dFilter = (s) => !arr || (s?.transactionat && isDateBetween(handleValidDate(s?.transactionat, "YYYY/MM/DD"), t2Start, t2End));
                        const bFilter = (s) => branch && branch.value ? s?.branchId === branch.value : true;
                        const pFilter = (a) => partner && partner.value ? a?.agencyId === partner.value : true;
                        const mFilter = (sales) => marketing ? (sales?.name ?? "").toLowerCase().indexOf(marketing.toLowerCase()) !== -1 : true;

                        const filtered = (agentList || []).filter(pFilter && mFilter);
                        const allSales = filtered.flatMap(s => (s.agent_sales || []).filter(a => bFilter(a) && dFilter(a)));
                        const tVisit = customers.length;
                        const tBooking = allSales.filter(a => a.transactionat !== null).length;
                        const tKantor = allSales.filter(a => (a.typeId === 1 || a.typeId === 2) && a.docat !== null).length;
                        const tAkad = allSales.filter(a => (a.typeId === 1 || a.typeId === 2) && a.completedat !== null).length;
                        const tReject = allSales.filter(a => (a.typeId === 1 || a.typeId === 2) && (a.statusBankId === 2 || a.statusBankId === 3)).length;
                        const tCancel = allSales.filter(a => a.statusId === 6).length;
                        const tCash = allSales.filter(a => (a.typeId === 3 || a.typeId === 4) && a.statusId === 6).length;

                        const tMkt = new Set(filtered.map(a => a.id)).size;
                        const cepat = allSales.filter(a => a.docat && a.transactionat && moment(a.docat).diff(moment(a.transactionat), "days") <= 7).length;
                        const sla = tKantor > 0 ? Math.round(cepat / tKantor * 100) : 0;
                        const bkun = tVisit > 0 ? Math.round(tBooking / tVisit * 100) : 0;
                        const bk2be = tBooking > 0 ? Math.round(tKantor / tBooking * 100) : 0;
                        const bk2cash = tBooking > 0 ? Math.round(tCash / tBooking * 100) : 0;
                        const bk2cnc = tBooking > 0 ? Math.round(tCancel / tBooking * 100) : 0;
                        const be2ak = tKantor > 0 ? Math.round(tAkad / tKantor * 100) : 0;
                        const bk2ak = tBooking > 0 ? Math.round(tAkad / tBooking * 100) : 0;
                        const loss = tBooking > 0 ? Math.round(tCancel / tBooking * 100) : 0;

                        const mmap = {};
                        allSales.forEach(s => {
                          if (!s.transactionat) return;
                          const m = moment(s.transactionat).format("YYYY-MM");
                          if (!mmap[m]) mmap[m] = { b: 0, k: 0, a: 0 };
                          mmap[m].b += 1;
                          if (s.docat) mmap[m].k += 1;
                          if (s.completedat) mmap[m].a += 1;
                        });
                        const mKeys = Object.keys(mmap).sort();
                        const trB = mKeys.map(m => mmap[m].b);
                        const trK = mKeys.map(m => mmap[m].k);
                        const trA = mKeys.map(m => mmap[m].a);

                        return (
                          <>
                            <Row>
                              {[
                                { icon: "ri-booklet-line", bg: "primary", label: "Kunjungan", value: tVisit.toLocaleString("id"), sub: `${bkun}% sampai booking` },
                                { icon: "ri-file-list-3-line", bg: "primary", label: "Booking", value: tBooking.toLocaleString("id"), sub: `${tMkt} marketing` },
                                { icon: "ri-folder-2-line", bg: "info", label: "Berkas Lengkap", value: tKantor.toLocaleString("id"), sub: `${bk2be}% dari booking` },
                                { icon: "ri-shake-hands-line", bg: "success", label: "Akad", value: tAkad.toLocaleString("id"), sub: `${bk2ak}% dari booking` },
                                { icon: "ri-money-dollar-circle-line", bg: "warning", label: "Cash", value: tCash.toLocaleString("id"), sub: `${bk2cash}% dari booking` },
                                { icon: "ri-flashlight-line", bg: "secondary", label: "Berkas ≤7 Hari", value: `${sla}%`, sub: `${cepat.toLocaleString("id")} berkas cepat` },
                                { icon: "ri-close-circle-line", bg: "danger", label: "Reject", value: tReject.toLocaleString("id"), sub: `${Math.round(tReject / (tBooking || 1) * 100)}% dari booking` },
                                { icon: "ri-forbid-line", bg: "dark", label: "Cancel", value: tCancel.toLocaleString("id"), sub: `${Math.round(tCancel / (tBooking || 1) * 100)}% dari booking` },
                              ].map((kpi, idx) => (
                                <Col key={idx} className="mb-2">
                                  <Card className="card-animate h-100">
                                    <CardBody>
                                      <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                          <p className="text-uppercase fw-medium text-muted text-truncate mb-1">{kpi.label}</p>
                                          <h4 className="fs-22 fw-semibold ff-secondary mb-1">{kpi.value}</h4>
                                          <p className="text-muted fs-13 mb-0">{kpi.sub}</p>
                                        </div>
                                        <div className="flex-shrink-0" style={{ width: "30px" }}>
                                          <div className={`avatar-sm rounded bg-${kpi.bg}-subtle d-flex align-items-center justify-content-center`}>
                                            <i className={`${kpi.icon} fs-22 text-${kpi.bg}`}></i>
                                          </div>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                              ))}
                            </Row>

                            <Card className="mt-3">
                              <CardBody>
                                <Nav className="nav-tabs nav-tabs-custom nav-success mb-3" role="tablist">
                                  {[
                                    { key: "ringkasan", label: "Ringkasan & Standar", icon: "ri-bar-chart-2-line" },
                                    { key: "ranking", label: "Ranking Indikator", icon: "ri-trophy-line" },
                                    { key: "bulan", label: "Ranking per Bulan", icon: "ri-calendar-line" },
                                    { key: "konversi", label: "Konversi Custom", icon: "ri-swap-line" },
                                    { key: "rapor", label: "Rapor Marketing", icon: "ri-file-user-line" },
                                  ].map(s => (
                                    <NavItem key={s.key}>
                                      <NavLink
                                        className={classnames({ active: subTab === s.key }, "fw-semibold")}
                                        onClick={() => setSubTab(s.key)}
                                        href="#">
                                        <i className={`${s.icon} me-1 align-bottom`}></i>{s.label}
                                      </NavLink>
                                    </NavItem>
                                  ))}
                                </Nav>

                                {subTab === "ringkasan" && (
                                  <>
                                    <Row>
                                      <Col xl={6}>
                                        <div className="mb-3">
                                          <h5 className="card-title mb-1">Funnel Pipeline</h5>
                                          <p className="text-muted fs-13 mb-3">Alur dari Booking sampai Cancel (data terfilter)</p>
                                          <ReactApexChart
                                            options={{
                                              chart: { type: "bar", height: 320, toolbar: { show: false } },
                                              plotOptions: { bar: { horizontal: true, barHeight: "60%", borderRadius: 6, distributed: true } },
                                              colors: ["#f596fb", "#BDB395", "#75fbfd", "#9fc5e8", "#F9B637", "#E73F1E"],
                                              dataLabels: { enabled: true, formatter: (val) => `${val}`, style: { fontWeight: 600, fontSize: "12px", colors: ["#fff"] } },
                                              xaxis: { categories: ["Booking", "Berkas Lengkap", "Akad", "Cash", "Reject", "Cancel"], labels: { style: { fontWeight: 500, fontSize: "12px" } } },
                                              yaxis: { labels: { style: { fontWeight: 500, fontSize: "12px" } } },
                                              grid: { borderColor: "#f1f1f1" },
                                            }}
                                            series={[{ data: [tBooking, tKantor, tAkad, tCash, tReject, tCancel] }]}
                                            className="apex-charts"
                                            type="bar"
                                            height={320}
                                          />
                                        </div>
                                      </Col>
                                      <Col xl={6}>
                                        <div className="mb-3">
                                          <h5 className="card-title mb-1">Tren Bulanan</h5>
                                          <p className="text-muted fs-13 mb-3">Booking, Berkas Lengkap & Akad per bulan</p>
                                          <ReactApexChart
                                            options={{
                                              chart: { type: "line", height: 320, toolbar: { show: false }, zoom: { enabled: false } },
                                              stroke: { curve: "smooth", width: 2 },
                                              colors: ["#f596fb", "#BDB395", "#75fbfd"],
                                              markers: { size: 4, hover: { size: 6 } },
                                              xaxis: { categories: mKeys.map(m => moment(m).format("MMM YY")), labels: { style: { fontWeight: 500, fontSize: "11px" } } },
                                              yaxis: { labels: { style: { fontWeight: 500, fontSize: "11px" } } },
                                              grid: { borderColor: "#f1f1f1" },
                                              legend: { show: true, horizontalAlign: "center", position: "top", fontSize: "13px", markers: { width: 9, height: 9, radius: 6 } },
                                              tooltip: { shared: true, intersect: false },
                                            }}
                                            series={[
                                              { name: "Booking", data: trB },
                                              { name: "Berkas", data: trK },
                                              { name: "Akad", data: trA },
                                            ]}
                                            className="apex-charts"
                                            type="line"
                                            height={320}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                    <div className="table-responsive">
                                      <h5 className="card-title mb-2">Standar Indikator Penilaian</h5>
                                      <p className="text-muted fs-13 mb-3">Rubrik berbasis persentase: A ≥75% · B 50–74% · C 25–49% · D &lt;25%</p>
                                      <Table className="table-bordered mb-0">
                                        <thead className="table-light">
                                          <tr>
                                            <th>Indikator</th>
                                            <th>Basis Perhitungan</th>
                                            <th className="text-success">A</th>
                                            <th className="text-info">B</th>
                                            <th className="text-warning">C</th>
                                            <th className="text-danger">D</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr><td>Jumlah Booking</td><td>Jumlah (unit)</td><td>≥25</td><td>14–24</td><td>5–13</td><td>≤4</td></tr>
                                          <tr><td>Berkas Lengkap</td><td>% dari Booking</td><td>≥75%</td><td>50–74%</td><td>25–49%</td><td>&lt;25%</td></tr>
                                          <tr><td>Akad (dari Berkas)</td><td>% dari Berkas</td><td>≥75%</td><td>50–74%</td><td>25–49%</td><td>&lt;25%</td></tr>
                                          <tr><td>Cash</td><td>Jumlah (unit)</td><td>≥3</td><td>2</td><td>1</td><td>0</td></tr>
                                          <tr><td>Berkas ≤7 Hari</td><td>% dari Berkas</td><td>≥60%</td><td>45–59%</td><td>30–44%</td><td>&lt;30%</td></tr>
                                          <tr><td>Reject</td><td>% dari Berkas</td><td>&lt;25%</td><td>25–49%</td><td>50–74%</td><td>≥75%</td></tr>
                                          <tr><td>Cancel</td><td>% dari Booking</td><td>&lt;25%</td><td>25–49%</td><td>50–74%</td><td>≥75%</td></tr>
                                        </tbody>
                                      </Table>
                                    </div>
                                    <div className="mt-3">
                                      <div className="text-muted fs-12 mb-2"><i className="ri-lightbulb-line align-middle me-1"></i> <b>Berkas Lengkap ≤ 7 hari kalender dari Booking = BAGUS.</b> Dinilai terpisah sebagai SLA Kecepatan Berkas: A ≥60% · B 45–59% · C 30–44% · D &lt;30%.</div>
                                      <div className="text-muted fs-12 mb-2"><i className="ri-award-line align-middle me-1"></i> <b>Level otomatis dari Jumlah Booking</b> (dihitung ulang tiap bulan &amp; mengikuti filter): <i className="ri-vip-diamond-line align-middle"></i> <b>Platinum</b> ≥20 · <i className="ri-medal-line align-middle"></i> <b>Gold</b> 15–19 · <i className="ri-medal-line align-middle"></i> <b>Silver</b> 10–14 · <i className="ri-medal-line align-middle"></i> <b>Bronze</b> 5–9 · <i className="ri-checkbox-blank-circle-line align-middle"></i> <b>No Level</b> ≤4.</div>
                                      <div className="text-muted fs-12 mb-2"><i className="ri-checkbox-circle-line align-middle me-1"></i> <b>A selalu = terbaik.</b> Indikator positif (<i className="ri-file-list-3-line align-middle"></i> Booking, <i className="ri-folder-2-line align-middle"></i> Berkas Lengkap, <i className="ri-handshake-line align-middle"></i> Akad, <i className="ri-money-dollar-circle-line align-middle"></i> Cash): makin banyak/tinggi makin baik. Indikator risiko <i className="ri-alert-line align-middle"></i> (<i className="ri-folder-open-line align-middle"></i> Berkas Belum, <i className="ri-close-circle-line align-middle"></i> Reject, <i className="ri-forbid-line align-middle"></i> Cancel): makin kecil persentasenya makin baik (A = &lt;25%).</div>
                                      <div className="text-muted fs-12 mb-0"><i className="ri-folder-open-line align-middle me-1"></i> <b>Berkas Belum = sisa Booking</b> setelah dikurangi Berkas Lengkap, Cash, Reject, dan Cancel — yaitu booking yang statusnya masih "BOOKING" dan berkasnya belum masuk. Karena satu deal bisa sekaligus "pernah berkas" lalu "reject/cancel", sisa dihitung berdasar keanggotaan (bukan pengurangan angka) agar tidak dobel dan tidak minus.</div>
                                    </div>
                                  </>
                                )}

                                {subTab === "ranking" && (() => {
                                  const INDICATORS = [
                                    { key: "booking", label: "Booking", icon: "ri-file-list-3-line" },
                                    { key: "belum", label: "Berkas Belum", icon: "ri-folder-open-line" },
                                    { key: "berkas", label: "Berkas Lengkap", icon: "ri-folder-2-line" },
                                    { key: "akad", label: "Akad", icon: "ri-handshake-line" },
                                    { key: "reject", label: "Reject", icon: "ri-close-circle-line" },
                                    { key: "cancel", label: "Cancel", icon: "ri-forbid-line" },
                                    { key: "cash", label: "Cash", icon: "ri-money-dollar-circle-line" },
                                    { key: "sla7", label: "SLA \u22647 Hari", icon: "ri-flashlight-line" },
                                  ];
                                  const LVLS = [
                                    { key: "all", label: "Semua Level" },
                                    { key: "platinum", label: "Platinum" },
                                    { key: "gold", label: "Gold" },
                                    { key: "silver", label: "Silver" },
                                    { key: "bronze", label: "Bronze" },
                                    { key: "none", label: "No Level" },
                                  ];
                                  const isSLA = rankInd === "sla7";
                                  const cfg = isSLA ? null : STD[rankInd];
                                  let rankingRows = [...filtered].map(agent => {
                                    const sales = (agent.agent_sales || []).filter(s => bFilter(s) && dFilter(s));
                                    const booking = sales.filter(s => s.transactionat !== null).length;
                                    const be = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.docat !== null).length;
                                    const ak = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.completedat !== null).length;
                                    const rj = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && (s.statusBankId === 2 || s.statusBankId === 3)).length;
                                    const cn = sales.filter(s => s.statusId === 6).length;
                                    const ch = sales.filter(s => s.typeId === 3 || s.typeId === 4).length;
                                    const blm = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.transactionat !== null && s.docat === null && s.statusId !== 6 && s.statusBankId !== 2 && s.statusBankId !== 3).length;
                                    const s7 = sales.filter(s => s.docat && s.transactionat && moment(s.docat).diff(moment(s.transactionat), "days") <= 7).length;
                                    return { agent, booking, be, ak, rj, cn, ch, blm, s7 };
                                  });
                                  if (rankLvl !== "all") {
                                    rankingRows = rankingRows.filter(a => levelOf(a.booking).key === rankLvl);
                                  }
                                  rankingRows = rankingRows.filter(a => a.booking >= (rankLvl === "all" ? minBook : 1));
                                  rankingRows.forEach(a => {
                                    if (isSLA) {
                                      a._v = a.be ? Math.round(a.s7 / a.be * 100) : 0;
                                      a._g = gradeSLA(a._v);
                                      a._disp = a._v + "%";
                                    } else {
                                      const r = indVal(a, rankInd);
                                      a._v = r.v;
                                      a._g = r.grade;
                                      a._disp = r.disp;
                                    }
                                  });
                                  const goodUp = isSLA || cfg?.good !== "down";
                                  rankingRows.sort((x, y) => goodUp ? y._v - x._v : x._v - y._v);
                                  if (rankTb === "bottom") rankingRows.reverse();
                                  rankingRows = rankingRows.slice(0, 50);
                                  const indLabel = isSLA ? "SLA Berkas \u22647 Hari (%)" : STD[rankInd].label;
                                  const indIcon = INDICATORS.find(i => i.key === rankInd)?.icon || "ri-trophy-line";
                                  const isPct = !isSLA && cfg?.kind === "pct";
                                  const valHeader = isSLA ? "SLA \u22647h" : isPct ? "Persentase" : indLabel;
                                  return (
                                    <div>
                                      <Nav className="nav-tabs nav-tabs-custom nav-success mb-3" role="tablist">
                                        {INDICATORS.map(ind => (
                                          <NavItem key={ind.key}>
                                            <NavLink className={classnames({ active: rankInd === ind.key }, "fw-semibold")} onClick={() => setRankInd(ind.key)} href="#">
                                              <i className={`${ind.icon} me-1 align-bottom`}></i>{ind.label}
                                            </NavLink>
                                          </NavItem>
                                        ))}
                                      </Nav>
                                      <Row className="mb-3 align-items-center">
                                        <Col sm={6}>
                                          <Nav className="nav-pills" role="tablist">
                                            <NavItem>
                                              <NavLink className={classnames({ active: rankTb === "top" }, "fw-semibold")} onClick={() => setRankTb("top")} href="#">
                                                <i className="ri-arrow-up-line me-1 align-bottom"></i>Top 50
                                              </NavLink>
                                            </NavItem>
                                            <NavItem>
                                              <NavLink className={classnames({ active: rankTb === "bottom" }, "fw-semibold")} onClick={() => setRankTb("bottom")} href="#">
                                                <i className="ri-arrow-down-line me-1 align-bottom"></i>Bottom 50
                                              </NavLink>
                                            </NavItem>
                                          </Nav>
                                        </Col>
                                        <Col sm={6}>
                                          <Nav className="nav-pills justify-content-end" role="tablist">
                                            {LVLS.map(lvl => (
                                              <NavItem key={lvl.key}>
                                                <NavLink className={classnames({ active: rankLvl === lvl.key }, "fw-semibold")} onClick={() => setRankLvl(lvl.key)} href="#">
                                                  {lvl.label}
                                                </NavLink>
                                              </NavItem>
                                            ))}
                                          </Nav>
                                        </Col>
                                      </Row>
                                      <h5 className="card-title mb-1">
                                        <i className={`${indIcon} me-1 align-bottom`}></i>{rankTb === "top" ? "Top" : "Bottom"} 50 — {indLabel}
                                      </h5>
                                      <p className="text-muted fs-13 mb-3">
                                        {rankingRows.length} marketing {rankLvl === "all" ? `(min. ${minBook} booking)` : `(Level ${LVLS.find(l => l.key === rankLvl)?.label} — batas min. booking diabaikan agar level ini tampil utuh)`}. {rankTb === "top" ? "Menampilkan yang TERBAIK" : "Menampilkan yang TERBAWAH"}.
                                        {!isSLA && cfg?.good === "down" ? " \u26A0\uFE0F indikator risiko: makin kecil makin baik." : ""}
                                      </p>
                                      <div className="table-responsive table-card mt-3">
                                        <Table hover className="align-middle table-hover table-nowrap mb-0">
                                          <thead className="table-light">
                                            <tr>
                                              <th style={{ width: "40px" }}>#</th>
                                              <th>NAMA SALES</th>
                                              <th className="text-center">MITRA</th>
                                              <th className="text-center">LEVEL</th>
                                              <th className="text-center">{valHeader}</th>
                                              <th className="text-center">NILAI</th>
                                              <th className="text-center">BOOKING</th>
                                              <th className="text-center">BERKAS</th>
                                              <th className="text-center">AKAD</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {rankingRows.map((row, idx) => {
                                              const L = levelOf(row.booking);
                                              const lvlColors = { platinum: "#B9F2FF", gold: "#FFD700", silver: "#C0C0C0", bronze: "#CD7F32", none: "#555" };
                                              const lvlTexts = { platinum: "dark", gold: "dark", silver: "dark", bronze: "white", none: "white" };
                                              return (
                                                <tr key={idx} className="cursor-pointer fw-semibold" onClick={() => { setInfo(row.agent); setExpense(row.agent.agent_sales || []); expanseDataRef.current = row.agent.agent_sales || []; toggle(); }}>
                                                  <td>{idx + 1}</td>
                                                  <td>{row.agent.name} {row.agent?.agency_agent?.name}</td>
                                                  <td className="text-center"><span className="badge bg-light text-dark">{row.agent?.agency_agent?.name || "-"}</span></td>
                                                  <td className="text-center"><span style={{ backgroundColor: lvlColors[L.key] }} className={`badge text-${lvlTexts[L.key]}`}>{L.label}</span></td>
                                                  <td className="text-center fw-bold">{row._disp}</td>
                                                  <td className="text-center"><span className={`badge bg-${gradeColor(row._g)} fs-12`}>{row._g}</span></td>
                                                  <td className="text-center">{row.booking}</td>
                                                  <td className="text-center">{row.be}</td>
                                                  <td className="text-center">{row.ak}</td>
                                                </tr>
                                              );
                                            })}
                                            {rankingRows.length === 0 && (<tr><td colSpan={9} className="text-center text-muted py-3">Tidak ada data</td></tr>)}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </div>
                                  );
                                })()}

                                {subTab === "bulan" && (() => {
                                  const BUL_INDICATORS = [
                                    { key: "booking", label: "Booking", icon: "ri-file-list-3-line" },
                                    { key: "belum", label: "Berkas Belum", icon: "ri-folder-open-line" },
                                    { key: "berkas", label: "Berkas Lengkap", icon: "ri-folder-2-line" },
                                    { key: "akad", label: "Akad", icon: "ri-handshake-line" },
                                    { key: "reject", label: "Reject", icon: "ri-close-circle-line" },
                                    { key: "cancel", label: "Cancel", icon: "ri-forbid-line" },
                                    { key: "cash", label: "Cash", icon: "ri-money-dollar-circle-line" },
                                  ];
                                  const selMonth = bulanMonth || (mKeys.length > 0 ? mKeys[mKeys.length - 1] : "");
                                  let bulanRows = [...filtered].map(agent => {
                                    const sales = (agent.agent_sales || []).filter(s => bFilter(s) && dFilter(s) && s.transactionat && moment(s.transactionat).format("YYYY-MM") === selMonth);
                                    const booking = sales.filter(s => s.transactionat !== null).length;
                                    const be = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.docat !== null).length;
                                    const ak = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.completedat !== null).length;
                                    const rj = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && (s.statusBankId === 2 || s.statusBankId === 3)).length;
                                    const cn = sales.filter(s => s.statusId === 6 && (s.typeId === 1 || s.typeId === 2)).length;
                                    const ch = sales.filter(s => s.typeId === 3 || s.typeId === 4).length;
                                    const blm = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.transactionat !== null && s.docat === null && s.statusId !== 6 && s.statusBankId !== 2 && s.statusBankId !== 3).length;
                                    return { agent, booking, be, ak, rj, cn, ch, blm };
                                  });
                                  bulanRows = bulanRows.filter(a => a.booking >= 1);
                                  const cfg = STD[bulanInd];
                                  const countOf = (a) => {
                                    switch (bulanInd) {
                                      case "booking": return a.booking;
                                      case "belum": return a.blm;
                                      case "berkas": return a.be;
                                      case "akad": return a.ak;
                                      case "reject": return a.rj;
                                      case "cancel": return a.cn;
                                      case "cash": return a.ch;
                                      default: return a.booking;
                                    }
                                  };
                                  const usePct = bulanMode === "persen" && cfg.kind === "pct";
                                  bulanRows.forEach(a => {
                                    const r = indVal(a, bulanInd);
                                    a._g = r.grade;
                                    if (usePct) { a._v = r.v; a._disp = r.v + "%"; }
                                    else { a._v = countOf(a); a._disp = String(a._v); }
                                  });
                                  const goodUp = cfg.good !== "down";
                                  bulanRows.sort((x, y) => goodUp ? y._v - x._v : x._v - y._v);
                                  if (bulanTb === "bottom") bulanRows.reverse();
                                  bulanRows = bulanRows.slice(0, 50);
                                  const valHead = usePct ? "Persentase" : (cfg.kind === "pct" ? cfg.label + " (jml)" : cfg.label);
                                  return (
                                    <div>
                                      <Row className="mb-3 align-items-end">
                                        <Col sm={3}>
                                          <div className="mb-2">
                                            <label className="form-label fw-semibold">Pilih Bulan</label>
                                            <Input type="select" className="form-select" value={selMonth} onChange={e => setBulanMonth(e.target.value)}>
                                              {mKeys.map(m => <option key={m} value={m}>{moment(m).format("MMM YYYY")}</option>)}
                                            </Input>
                                          </div>
                                        </Col>
                                        <Col sm={3}>
                                          <div className="mb-2">
                                            <label className="form-label fw-semibold">Dasar Nilai</label>
                                            <div>
                                              <Nav className="nav-pills" role="tablist">
                                                <NavItem>
                                                  <NavLink className={classnames({ active: bulanMode === "angka" }, "fw-semibold")} onClick={() => setBulanMode("angka")} href="#">
                                                    <i className="ri-number-1 me-1 align-bottom"></i>Angka
                                                  </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                  <NavLink className={classnames({ active: bulanMode === "persen" }, "fw-semibold")} onClick={() => setBulanMode("persen")} href="#">
                                                    <i className="ri-percent-line me-1 align-bottom"></i>Persentase
                                                  </NavLink>
                                                </NavItem>
                                              </Nav>
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                      <Nav className="nav-tabs nav-tabs-custom nav-success mb-3" role="tablist">
                                        {BUL_INDICATORS.map(ind => (
                                          <NavItem key={ind.key}>
                                            <NavLink className={classnames({ active: bulanInd === ind.key }, "fw-semibold")} onClick={() => setBulanInd(ind.key)} href="#">
                                              <i className={`${ind.icon} me-1 align-bottom`}></i>{ind.label}
                                            </NavLink>
                                          </NavItem>
                                        ))}
                                      </Nav>
                                      <Row className="mb-3 align-items-center">
                                        <Col sm={12}>
                                          <Nav className="nav-pills" role="tablist">
                                            <NavItem>
                                              <NavLink className={classnames({ active: bulanTb === "top" }, "fw-semibold")} onClick={() => setBulanTb("top")} href="#">
                                                <i className="ri-arrow-up-line me-1 align-bottom"></i>Top 50
                                              </NavLink>
                                            </NavItem>
                                            <NavItem>
                                              <NavLink className={classnames({ active: bulanTb === "bottom" }, "fw-semibold")} onClick={() => setBulanTb("bottom")} href="#">
                                                <i className="ri-arrow-down-line me-1 align-bottom"></i>Bottom 50
                                              </NavLink>
                                            </NavItem>
                                          </Nav>
                                        </Col>
                                      </Row>
                                      <h5 className="card-title mb-1">
                                        <i className="ri-calendar-line me-1 align-bottom"></i>{bulanTb === "top" ? "Top" : "Bottom"} 50 — {cfg.label} · {moment(selMonth).format("MMM YYYY")}
                                      </h5>
                                      <p className="text-muted fs-13 mb-3">
                                        {bulanRows.length} marketing aktif pada bulan ini. {usePct ? "Dasar: persentase." : (cfg.kind === "pct" ? "Dasar: jumlah angka (persentase tersedia via toggle)." : "Dasar: jumlah angka.")}
                                        {cfg.good === "down" ? " Indikator risiko: makin kecil makin baik." : ""}
                                      </p>
                                      <div className="table-responsive table-card">
                                        <Table hover className="align-middle table-hover table-nowrap mb-0">
                                          <thead className="table-light">
                                            <tr>
                                              <th style={{ width: "40px" }}>#</th>
                                              <th>NAMA SALES</th>
                                              <th className="text-center">TIM</th>
                                              <th className="text-center">{valHead}</th>
                                              <th className="text-center">NILAI</th>
                                              <th className="text-center">BOOKING</th>
                                              <th className="text-center">BERKAS</th>
                                              <th className="text-center">AKAD</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {bulanRows.map((row, idx) => (
                                              <tr key={idx} className="cursor-pointer fw-semibold" onClick={() => { setInfo(row.agent); setExpense(row.agent.agent_sales || []); expanseDataRef.current = row.agent.agent_sales || []; toggle(); }}>
                                                <td>{idx + 1}</td>
                                                <td>{row.agent.name} {row.agent?.agency_agent?.name}</td>
                                                <td className="text-center"><span className="badge bg-light text-dark">{row.agent?.agency_agent?.name || "-"}</span></td>
                                                <td className="text-center fw-bold">{row._disp}</td>
                                                <td className="text-center"><span className={`badge bg-${gradeColor(row._g)} fs-12`}>{row._g}</span></td>
                                                <td className="text-center">{row.booking}</td>
                                                <td className="text-center">{row.be}</td>
                                                <td className="text-center">{row.ak}</td>
                                              </tr>
                                            ))}
                                            {bulanRows.length === 0 && (<tr><td colSpan={8} className="text-center text-muted py-3">Tidak ada data</td></tr>)}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </div>
                                  );
                                })()}

                                {subTab === "konversi" && (() => {
                                  const CONV_INDICATORS = [
                                    { key: "bk2be", label: "Booking → Berkas", icon: "ri-arrow-right-circle-line" },
                                    { key: "be2ak", label: "Berkas → Akad", icon: "ri-arrow-right-circle-line" },
                                    { key: "bk2ak", label: "Booking → Akad", icon: "ri-arrow-right-circle-line" },
                                    { key: "loss", label: "Booking → Reject/Cancel", icon: "ri-close-circle-line" },
                                  ];
                                  const cfg = CONV[convKey];
                                  let convRows = [...filtered].map(agent => {
                                    const sales = (agent.agent_sales || []).filter(s => bFilter(s) && dFilter(s));
                                    const booking = sales.filter(s => s.transactionat !== null).length;
                                    const be = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.docat !== null).length;
                                    const ak = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.completedat !== null).length;
                                    const rj = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && (s.statusBankId === 2 || s.statusBankId === 3)).length;
                                    const cn = sales.filter(s => s.statusId === 6 && (s.typeId === 1 || s.typeId === 2)).length;
                                    return { agent, booking, be, ak, rj, cn };
                                  });
                                  convRows = convRows.filter(a => a.booking >= minBook);
                                  convRows.forEach(a => {
                                    const num = cfg.num === "loss" ? (a.rj + a.cn) : a[cfg.num];
                                    const den = a[cfg.den];
                                    a._num = num;
                                    a._den = den;
                                    a._v = den ? Math.round(num / den * 100) : 0;
                                    a._g = gradeVal(cfg, a._v);
                                  });
                                  if (convKey === "be2ak") convRows = convRows.filter(a => a.be > 0);
                                  convRows.sort((x, y) => cfg.dir === "up" ? y._v - x._v : x._v - y._v);
                                  if (convTb === "bottom") convRows.reverse();
                                  convRows = convRows.slice(0, 50);
                                  return (
                                    <div>
                                      <Nav className="nav-tabs nav-tabs-custom nav-success mb-3" role="tablist">
                                        {CONV_INDICATORS.map(c => (
                                          <NavItem key={c.key}>
                                            <NavLink className={classnames({ active: convKey === c.key }, "fw-semibold")} onClick={() => setConvKey(c.key)} href="#">
                                              <i className={`${c.icon} me-1 align-bottom`}></i>{c.label}
                                            </NavLink>
                                          </NavItem>
                                        ))}
                                      </Nav>
                                      <Row className="mb-3">
                                        <Col sm={12}>
                                          <Nav className="nav-pills" role="tablist">
                                            <NavItem>
                                              <NavLink className={classnames({ active: convTb === "top" }, "fw-semibold")} onClick={() => setConvTb("top")} href="#">
                                                <i className="ri-arrow-up-line me-1 align-bottom"></i>Top 50
                                              </NavLink>
                                            </NavItem>
                                            <NavItem>
                                              <NavLink className={classnames({ active: convTb === "bottom" }, "fw-semibold")} onClick={() => setConvTb("bottom")} href="#">
                                                <i className="ri-arrow-down-line me-1 align-bottom"></i>Bottom 50
                                              </NavLink>
                                            </NavItem>
                                          </Nav>
                                        </Col>
                                      </Row>
                                      <h5 className="card-title mb-1">
                                        <i className="ri-swap-line me-1 align-bottom"></i>{convTb === "top" ? "Top" : "Bottom"} 50 — Konversi {cfg.label}
                                      </h5>
                                      <p className="text-muted fs-13 mb-3">
                                        {convKey === "loss"
                                          ? "Rasio kehilangan — makin kecil makin baik (A = < 25%)."
                                          : "Rasio makin tinggi makin baik (A = ≥ 75%)."}
                                        {" "}Rubrik: A · B · C · D di ambang 75/50/25%. Min. {minBook} booking.
                                      </p>
                                      <div className="table-responsive table-card">
                                        <Table hover className="align-middle table-hover table-nowrap mb-0">
                                          <thead className="table-light">
                                            <tr>
                                              <th style={{ width: "40px" }}>#</th>
                                              <th>NAMA SALES</th>
                                              <th className="text-center">TIM</th>
                                              <th className="text-center">RASIO</th>
                                              <th className="text-center">NILAI</th>
                                              <th className="text-center">PROGRESS</th>
                                              <th className="text-center">PEMBILANG</th>
                                              <th className="text-center">PENYEBUT</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {convRows.map((row, idx) => (
                                              <tr key={idx} className="cursor-pointer fw-semibold" onClick={() => { setInfo(row.agent); setExpense(row.agent.agent_sales || []); expanseDataRef.current = row.agent.agent_sales || []; toggle(); }}>
                                                <td>{idx + 1}</td>
                                                <td>{row.agent.name} {row.agent?.agency_agent?.name}</td>
                                                <td className="text-center"><span className="badge bg-light text-dark">{row.agent?.agency_agent?.name || "-"}</span></td>
                                                <td className="text-center fw-bold">{row._v}%</td>
                                                <td className="text-center"><span className={`badge bg-${gradeColor(row._g)}`}>{row._g}</span></td>
                                                <td>
                                                  <div className="progress" style={{ height: "6px" }}>
                                                    <div className="progress-bar bg-success" style={{ width: `${Math.min(row._v, 100)}%` }}></div>
                                                  </div>
                                                </td>
                                                <td className="text-center">{row._num}</td>
                                                <td className="text-center">{row._den}</td>
                                              </tr>
                                            ))}
                                            {convRows.length === 0 && (
                                              <tr><td colSpan={8} className="text-center text-muted py-4">Tidak ada data untuk filter ini.</td></tr>
                                            )}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </div>
                                  );
                                })()}

                                {subTab === "rapor" && (() => {
                                  const pts = { A: 4, B: 3, C: 2, D: 1 };
                                  const raporAgents = [...filtered]
                                    .map(a => {
                                      const sales = (a.agent_sales || []).filter(s => bFilter(s) && dFilter(s));
                                      const booking = sales.filter(s => s.transactionat !== null).length;
                                      return { agent: a, booking };
                                    })
                                    .sort((x, y) => y.booking - x.booking);
                                  const selMid = raporMid && raporAgents.find(a => String(a.agent.id) === String(raporMid)) ? raporMid : (raporAgents[0]?.agent.id ?? "");
                                  const selRow = raporAgents.find(a => String(a.agent.id) === String(selMid));
                                  if (!selRow) {
                                    return (
                                      <div className="text-center text-muted py-5">
                                        <i className="ri-file-user-line fs-40 mb-3 d-block"></i>
                                        <h5>Rapor Marketing</h5>
                                        <p className="mb-0">Tidak ada data marketing pada filter ini.</p>
                                      </div>
                                    );
                                  }
                                  const a = selRow.agent;
                                  const sales = (a.agent_sales || []).filter(s => bFilter(s) && dFilter(s));
                                  const booking = sales.filter(s => s.transactionat !== null).length;
                                  const be = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.docat !== null).length;
                                  const ak = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.completedat !== null).length;
                                  const rj = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && (s.statusBankId === 2 || s.statusBankId === 3)).length;
                                  const cn = sales.filter(s => s.statusId === 6 && (s.typeId === 1 || s.typeId === 2)).length;
                                  const ch = sales.filter(s => s.typeId === 3 || s.typeId === 4).length;
                                  const blm = sales.filter(s => (s.typeId === 1 || s.typeId === 2) && s.transactionat !== null && s.docat === null && s.statusId !== 6 && s.statusBankId !== 2 && s.statusBankId !== 3).length;
                                  const s7 = sales.filter(s => s.docat && s.transactionat && moment(s.docat).diff(moment(s.transactionat), "days") <= 7).length;
                                  const belumP = booking ? Math.round(blm / booking * 100) : 0;
                                  const bk2be = booking ? Math.round(be / booking * 100) : 0;
                                  const be2ak = be ? Math.round(ak / be * 100) : 0;
                                  const bk2ak = booking ? Math.round(ak / booking * 100) : 0;
                                  const loss = booking ? Math.round((rj + cn) / booking * 100) : 0;
                                  const slaP = be ? Math.round(s7 / be * 100) : 0;
                                  const rejP = be ? Math.round(rj / be * 100) : 0;
                                  const g = {
                                    booking: indVal({ booking, be, ak, rj, cn, ch, blm }, "booking").grade,
                                    belum: indVal({ booking, be, ak, rj, cn, ch, blm }, "belum").grade,
                                    berkas: indVal({ booking, be, ak, rj, cn, ch, blm }, "berkas").grade,
                                    akad: indVal({ booking, be, ak, rj, cn, ch, blm }, "akad").grade,
                                    cash: indVal({ booking, be, ak, rj, cn, ch, blm }, "cash").grade,
                                    reject: indVal({ booking, be, ak, rj, cn, ch, blm }, "reject").grade,
                                    cancel: indVal({ booking, be, ak, rj, cn, ch, blm }, "cancel").grade,
                                    sla: gradeSLA(slaP),
                                  };
                                  const gradeKeys = ["booking", "belum", "berkas", "akad", "reject", "cancel", "sla"];
                                  const avg = gradeKeys.reduce((s, k) => s + pts[g[k]], 0) / gradeKeys.length;
                                  const overall = avg >= 3.5 ? "A" : avg >= 2.5 ? "B" : avg >= 1.5 ? "C" : "D";
                                  const byM = {};
                                  sales.forEach(s => {
                                    if (!s.transactionat) return;
                                    const m = moment(s.transactionat).format("YYYY-MM");
                                    const o = byM[m] || (byM[m] = { b: 0, be: 0, ak: 0 });
                                    o.b += 1;
                                    if ((s.typeId === 1 || s.typeId === 2) && s.docat) o.be += 1;
                                    if ((s.typeId === 1 || s.typeId === 2) && s.completedat) o.ak += 1;
                                  });
                                  const ms = Object.keys(byM).sort();
                                  let mom = "data belum cukup";
                                  if (ms.length >= 2) {
                                    const c = byM[ms[ms.length - 1]], p = byM[ms[ms.length - 2]];
                                    const db = c.b - p.b;
                                    mom = db > 0 ? `meningkat (+${db} booking vs bulan sebelumnya)` : db < 0 ? `menurun (${db} booking vs bulan sebelumnya)` : "stabil";
                                  }
                                  const lvlW = (v, hi, mid) => v >= hi ? "kuat" : v >= mid ? "cukup" : "perlu ditingkatkan";
                                  const risk = [];
                                  if (rejP >= 25) risk.push(`reject ${rejP}%`);
                                  if (belumP >= 25) risk.push(`berkas belum ${belumP}%`);
                                  let rec = "pertahankan konsistensi pipeline dan kejar berkas yang menggantung.";
                                  if (bk2be < 60) rec = "fokus mempercepat kelengkapan berkas dari booking (banyak booking belum jadi berkas).";
                                  else if (be2ak < 60) rec = "dorong berkas lengkap agar lanjut ke akad — konversi ke akad masih rendah.";
                                  else if (rejP >= 25) rec = "perketat kualitas calon debitur di awal (cek SLIK/riwayat kredit) untuk menekan reject.";
                                  else if (slaP < 45) rec = "percepat pengumpulan berkas agar ≤7 hari dari booking.";
                                  const nextMonthKey = (() => {
                                    if (!ms.length) return "";
                                    const lm = ms[ms.length - 1];
                                    const nd = moment(lm).add(1, "months");
                                    return nd.format("YYYY-MM");
                                  })();
                                  const lastM = ms.slice(-3);
                                  const wts = lastM.length === 3 ? [0.2, 0.3, 0.5] : lastM.length === 2 ? [0.35, 0.65] : [1];
                                  const proj = key => Math.round(lastM.reduce((s, m, i) => s + (byM[m][key] || 0) * wts[i], 0));
                                  const prevM = ms.length >= 2 ? byM[ms[ms.length - 2]] : null;
                                  const curM = byM[ms[ms.length - 1]];
                                  const tr = k => !prevM ? 0 : (curM[k] - prevM[k]);
                                  const tArrow = d => d > 0 ? <span className="text-success fw-bold">▲ +{d}</span> : d < 0 ? <span className="text-danger fw-bold">▼ {d}</span> : <span className="text-muted">▬ 0</span>;
                                  const trendMonths = [...new Set(filtered.flatMap(ag => (ag.agent_sales || []).map(s => s.transactionat ? moment(s.transactionat).format("YYYY-MM") : null).filter(Boolean)))].sort().slice(-6);
                                  const trendFinal = trendMonths.map(M => {
                                    const perAgent = {};
                                    filtered.forEach(ag => {
                                      const cnt = (ag.agent_sales || []).filter(s => bFilter(s) && dFilter(s) && s.transactionat && moment(s.transactionat).format("YYYY-MM") === M).length;
                                      if (cnt > 0) perAgent[String(ag.id)] = cnt;
                                    });
                                    const myBk = perAgent[String(a.id)] || 0;
                                    const sorted = Object.entries(perAgent).sort((x, y) => y[1] - x[1]);
                                    const rank = myBk > 0 ? sorted.findIndex(([m]) => m === String(a.id)) + 1 : null;
                                    return { M, myBk, rank, total: sorted.length };
                                  });
                                  let prevRank = null;
                                  const trendFinal2 = trendFinal.map(r => {
                                    let delta = "—";
                                    if (r.rank && prevRank) {
                                      const d = prevRank - r.rank;
                                      delta = d > 0 ? <span className="text-success fw-bold">▲ naik {d}</span> : d < 0 ? <span className="text-danger fw-bold">▼ turun {-d}</span> : <span className="text-muted">▬ tetap</span>;
                                    }
                                    if (r.rank) prevRank = r.rank;
                                    return { ...r, delta };
                                  });
                                  const daMonths = [...new Set(sales.flatMap(s => [
                                    s.transactionat ? moment(s.transactionat).format("YYYY-MM") : null,
                                    (s.typeId === 1 || s.typeId === 2) && s.docat ? moment(s.docat).format("YYYY-MM") : null,
                                    (s.typeId === 1 || s.typeId === 2) && s.sp3at ? moment(s.sp3at).format("YYYY-MM") : null,
                                    (s.typeId === 1 || s.typeId === 2) && s.completedat ? moment(s.completedat).format("YYYY-MM") : null,
                                  ].filter(Boolean)))].sort().slice(-3).reverse();
                                  const daBlocks = daMonths.map(M => {
                                    const [yy, mm] = M.split("-").map(Number);
                                    const nDays = new Date(yy, mm, 0).getDate();
                                    const days = {};
                                    for (let d = 1; d <= nDays; d++) {
                                      const dd = String(d).padStart(2, "0");
                                      const dow = new Date(yy, mm - 1, d).getDay();
                                      const hol = HOLIDAYS[`${M}-${dd}`];
                                      days[dd] = { bk: 0, be: 0, sp: 0, ak: 0, red: dow === 0 || dow === 6 || !!hol, title: hol ? `Libur: ${hol}` : dow === 0 ? "Minggu" : dow === 6 ? "Sabtu" : "" };
                                    }
                                    const bump = (getDate, key, typeOk) => sales.forEach(s => {
                                      if (!typeOk(s)) return;
                                      const v = getDate(s);
                                      if (!v) return;
                                      if (moment(v).format("YYYY-MM") === M) {
                                        const dd = moment(v).format("DD");
                                        if (days[dd]) days[dd][key]++;
                                      }
                                    });
                                    bump(s => s.transactionat, "bk", () => true);
                                    bump(s => s.docat, "be", s => s.typeId === 1 || s.typeId === 2);
                                    bump(s => s.sp3at, "sp", s => s.typeId === 1 || s.typeId === 2);
                                    bump(s => s.completedat, "ak", s => s.typeId === 1 || s.typeId === 2);
                                    let activeDays = 0;
                                    Object.keys(days).forEach(dd => { if (days[dd].bk || days[dd].be || days[dd].sp || days[dd].ak) activeDays++; });
                                    return { M, nDays, activeDays, days, dateKeys: Object.keys(days) };
                                  });
                                  const daRowDefs = [
                                    { key: "bk", label: "Booking", icon: "ri-file-list-3-line" },
                                    { key: "be", label: "Berkas Lengkap", icon: "ri-folder-2-line" },
                                    { key: "sp", label: "SP3K", icon: "ri-file-shield-line" },
                                    { key: "ak", label: "Akad", icon: "ri-handshake-line" },
                                  ];
                                  const initials = (a.name ?? "").split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
                                  const lvlColors = { platinum: "#B9F2FF", gold: "#FFD700", silver: "#C0C0C0", bronze: "#CD7F32", none: "#555" };
                                  const lvlTexts = { platinum: "dark", gold: "dark", silver: "dark", bronze: "white", none: "white" };
                                  const L = levelOf(booking);
                                  const scoreCards = [
                                    { icon: "ri-file-list-3-line", label: "Booking (unit)", value: booking, gr: g.booking },
                                    { icon: "ri-folder-open-line", label: "Berkas Belum", value: belumP + "%", gr: g.belum },
                                    { icon: "ri-folder-2-line", label: "Berkas Lengkap", value: bk2be + "%", gr: g.berkas },
                                    { icon: "ri-handshake-line", label: "Akad (dari berkas)", value: be2ak + "%", gr: g.akad },
                                    { icon: "ri-money-dollar-circle-line", label: "Cash (unit)", value: ch, gr: g.cash },
                                    { icon: "ri-close-circle-line", label: "Reject (dari berkas)", value: rejP + "%", gr: g.reject },
                                    { icon: "ri-forbid-line", label: "Cancel (dari booking)", value: booking ? Math.round(cn / booking * 100) + "%" : "0%", gr: g.cancel },
                                    { icon: "ri-flashlight-line", label: "Berkas ≤7 Hari", value: slaP + "%", gr: g.sla },
                                  ];
                                  const convRows = [
                                    { label: "Booking → Berkas", v: bk2be, gr: gradeVal(CONV.bk2be, bk2be) },
                                    { label: "Berkas → Akad", v: be2ak, gr: gradeVal(CONV.be2ak, be2ak) },
                                    { label: "Booking → Akad", v: bk2ak, gr: gradeVal(CONV.bk2ak, bk2ak) },
                                    { label: "Booking → Reject/Cancel", v: loss, gr: gradeVal(CONV.loss, loss) },
                                  ];
                                  return (
                                    <div>
                                      <Row className="mb-3">
                                        <Col sm={4}>
                                          <label className="form-label fw-semibold">Pilih Marketing</label>
                                          <Input type="select" className="form-select" value={String(selMid)} onChange={e => setRaporMid(e.target.value)}>
                                            {raporAgents.map(x => (
                                              <option key={x.agent.id} value={String(x.agent.id)}>{x.agent.name} · {x.agent?.agency_agent?.name || "-"} ({x.booking} booking)</option>
                                            ))}
                                          </Input>
                                        </Col>
                                      </Row>

                                      <Card className="mb-3">
                                        <CardBody>
                                          <div className="d-flex align-items-center gap-3 flex-wrap">
                                            <div className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white fw-bold" style={{ width: "56px", height: "56px", fontSize: "20px" }}>{initials}</div>
                                            <div className="flex-grow-1">
                                              <div className="fs-19 fw-bold">{a.name}</div>
                                              <div className="hstack gap-2 mt-1">
                                                <span className="badge bg-light text-dark">{a?.agency_agent?.name || "-"}</span>
                                                <span style={{ backgroundColor: lvlColors[L.key] }} className={`badge text-${lvlTexts[L.key]}`}>{L.label}</span>
                                                <span className="fs-11 text-muted">· {booking} booking pada periode terfilter</span>
                                              </div>
                                            </div>
                                            <div className="text-center">
                                              <div className="fs-11 text-muted fw-bold text-uppercase">Nilai Keseluruhan</div>
                                              <div className={`badge bg-${gradeColor(overall)} d-flex align-items-center justify-content-center mx-auto mt-2`} style={{ width: "56px", height: "56px", fontSize: "28px", borderRadius: "14px" }}>{overall}</div>
                                              <div className="fs-10 text-muted mt-2">rata-rata 7 indikator inti</div>
                                            </div>
                                          </div>
                                        </CardBody>
                                      </Card>

                                      <Card className="mb-3">
                                        <CardBody>
                                          <h5 className="card-title mb-1">Executive Summary <span className="fs-10 text-muted fw-semibold">· otomatis mengikuti filter</span></h5>
                                          <div className="mt-2 text-muted fs-13">
                                            <p className="mb-2"><b>{a.name}</b> (tim {a?.agency_agent?.name || "-"}) membukukan <b>{booking} booking</b> dengan nilai keseluruhan <b>{overall}</b> pada periode & filter terpilih.</p>
                                            <p className="mb-2">Alur berkas: <b>{bk2be}%</b> booking menjadi berkas lengkap, lalu <b>{be2ak}%</b> berkas berlanjut ke akad — konversi Booking→Akad <b>{bk2ak}%</b> ({lvlW(bk2ak, 60, 40)}).</p>
                                            <p className="mb-2">{risk.length ? `⚠️ Perlu perhatian: ${risk.join(" & ")} tergolong tinggi.` : `✅ Indikator risiko terkendali (reject ${rejP}%, berkas belum ${belumP}%).`}</p>
                                            <p className="mb-2">Kecepatan berkas ≤7 hari <b>{slaP}%</b> ({lvlW(slaP, 60, 40)}). Aktivitas booking {mom}.</p>
                                            <p className="mb-0"><b>Rekomendasi:</b> {rec}</p>
                                          </div>
                                        </CardBody>
                                      </Card>

                                      <Row>
                                        {scoreCards.map((c, i) => (
                                          <Col xl={3} md={6} sm={6} key={i}>
                                            <div className="card mb-3">
                                              <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center">
                                                  <span className="fs-12 fw-semibold text-muted"><i className={`${c.icon} me-1 align-middle`}></i>{c.label}</span>
                                                  <span className={`badge bg-${gradeColor(c.gr)} fs-12`}>{c.gr}</span>
                                                </div>
                                                <div className="fs-24 fw-bold mt-2">{c.value}</div>
                                              </div>
                                            </div>
                                          </Col>
                                        ))}
                                      </Row>

                                      <Row>
                                        <Col xl={6}>
                                          <div className="mb-3">
                                            <h5 className="card-title mb-1">Konversi (rincian angka)</h5>
                                            <div className="table-responsive table-card mt-2">
                                              <Table hover className="align-middle table-nowrap mb-0">
                                                <thead className="table-light">
                                                  <tr><th>Konversi</th><th className="text-center">Rasio</th><th className="text-center" style={{ width: "120px" }}>Progress</th><th className="text-center">Nilai</th></tr>
                                                </thead>
                                                <tbody>
                                                  {convRows.map((r, i) => (
                                                    <tr key={i}>
                                                      <td className="fw-semibold">{r.label}</td>
                                                      <td className="text-center fw-bold">{r.v}%</td>
                                                      <td>
                                                        <div className="progress" style={{ height: "6px" }}>
                                                          <div className="progress-bar bg-success" style={{ width: `${Math.min(r.v, 100)}%` }}></div>
                                                        </div>
                                                      </td>
                                                      <td className="text-center"><span className={`badge bg-${gradeColor(r.gr)}`}>{r.gr}</span></td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </Table>
                                            </div>
                                            <div className="text-muted fs-12 mt-2">Booking {booking} · Berkas Lengkap {be} · Berkas Belum {blm} · Akad {ak} · Cash {ch} · Reject {rj} · Cancel {cn}</div>
                                          </div>
                                        </Col>
                                        <Col xl={6}>
                                          <div className="mb-3">
                                            <h5 className="card-title mb-1">Aktivitas per Bulan</h5>
                                            <p className="text-muted fs-13 mb-3">Booking, Berkas Lengkap & Akad per bulan</p>
                                            <ReactApexChart
                                              options={{
                                                chart: { type: "bar", height: 260, toolbar: { show: false } },
                                                plotOptions: { bar: { columnWidth: "45%", borderRadius: 4 } },
                                                colors: ["#7c5cff", "#4dd4ff", "#22c55e"],
                                                dataLabels: { enabled: false },
                                                xaxis: { categories: ms.map(m => moment(m).format("MMM YY")), labels: { style: { fontWeight: 500, fontSize: "11px" } } },
                                                yaxis: { labels: { style: { fontWeight: 500, fontSize: "11px" } } },
                                                grid: { borderColor: "#f1f1f1" },
                                                legend: { show: true, horizontalAlign: "center", position: "top", fontSize: "12px", markers: { width: 9, height: 9, radius: 6 } },
                                                tooltip: { shared: true, intersect: false },
                                              }}
                                              series={[
                                                { name: "Booking", data: ms.map(m => byM[m].b) },
                                                { name: "Berkas", data: ms.map(m => byM[m].be) },
                                                { name: "Akad", data: ms.map(m => byM[m].ak) },
                                              ]}
                                              className="apex-charts"
                                              type="bar"
                                              height={260}
                                            />
                                          </div>
                                        </Col>
                                      </Row>

                                      {ms.length > 0 && (
                                        <Card className="mb-3">
                                          <CardBody>
                                            <h5 className="card-title mb-1">Forecast Bulan Depan — {nextMonthKey ? moment(nextMonthKey).format("MMM YYYY") : "-"}</h5>
                                            <p className="text-muted fs-13 mb-3">Estimasi dari rata-rata tertimbang 3 bulan terakhir (bulan terbaru bobot terbesar). Panah = perubahan bulan terakhir vs sebelumnya.</p>
                                            <Row>
                                              {[
                                                { icon: "ri-file-list-3-line", label: "Booking", v: proj("b"), d: tr("b") },
                                                { icon: "ri-folder-2-line", label: "Berkas Lengkap", v: proj("be"), d: tr("be") },
                                                { icon: "ri-handshake-line", label: "Akad", v: proj("ak"), d: tr("ak") },
                                              ].map((c, i) => (
                                                <Col md={4} key={i}>
                                                  <div className="card mb-0">
                                                    <div className="card-body">
                                                      <span className="fs-12 fw-semibold text-muted"><i className={`${c.icon} me-1 align-middle`}></i>{c.label}</span>
                                                      <div className="fs-24 fw-bold mt-2">{c.v}</div>
                                                      <div className="fs-11 mt-2">{tArrow(c.d)}</div>
                                                    </div>
                                                  </div>
                                                </Col>
                                              ))}
                                            </Row>
                                          </CardBody>
                                        </Card>
                                      )}

                                      <Card className="mb-3">
                                        <CardBody>
                                          <h5 className="card-title mb-1">Tren Peringkat & Level Bulanan <span className="fs-10 text-muted fw-semibold">· berdasarkan jumlah Booking</span></h5>
                                          <p className="text-muted fs-13 mb-3">Peringkat & klasifikasi Level otomatis tiap bulan (Platinum ≥20 · Gold 15–19 · Silver 10–14 · Bronze 5–9 · No Level ≤4). ▲ naik, ▼ turun peringkat.</p>
                                          <div className="table-responsive table-card">
                                            <Table hover className="align-middle table-nowrap mb-0">
                                              <thead className="table-light">
                                                <tr>
                                                  <th>Bulan</th>
                                                  <th className="text-center">Booking</th>
                                                  <th className="text-center">Level</th>
                                                  <th className="text-center">Peringkat</th>
                                                  <th className="text-center">Perubahan</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {trendFinal2.map((r, i) => {
                                                  const tL = levelOf(r.myBk);
                                                  return (
                                                    <tr key={i}>
                                                      <td className="fw-semibold">{moment(r.M).format("MMM YYYY")}</td>
                                                      <td className="text-center">{r.myBk || "·"}</td>
                                                      <td className="text-center"><span style={{ backgroundColor: lvlColors[tL.key] }} className={`badge text-${lvlTexts[tL.key]}`}>{tL.label}</span></td>
                                                      <td className="text-center fw-bold">{r.rank ? <>{`#${r.rank} `}<span className="fs-11 text-muted">/ {r.total}</span></> : "—"}</td>
                                                      <td className="text-center">{r.delta}</td>
                                                    </tr>
                                                  );
                                                })}
                                                {trendFinal2.length === 0 && (<tr><td colSpan={5} className="text-center text-muted py-3">Tidak ada data</td></tr>)}
                                              </tbody>
                                            </Table>
                                          </div>
                                        </CardBody>
                                      </Card>

                                      <Card>
                                        <CardBody>
                                          <h5 className="card-title mb-1">Ringkasan Reject</h5>
                                          <p className="text-muted fs-13 mb-3">Total reject pada periode & filter ini (rincian per penyebab tidak tersedia).</p>
                                          <Row>
                                            <Col md={4}>
                                              <div className="card mb-0">
                                                <div className="card-body">
                                                  <span className="fs-12 fw-semibold text-muted"><i className="ri-close-circle-line me-1 align-middle"></i>Total Reject</span>
                                                  <div className="fs-24 fw-bold mt-2">{rj}</div>
                                                </div>
                                              </div>
                                            </Col>
                                            <Col md={4}>
                                              <div className="card mb-0">
                                                <div className="card-body">
                                                  <span className="fs-12 fw-semibold text-muted"><i className="ri-percent-line me-1 align-middle"></i>Reject dari Berkas</span>
                                                  <div className="fs-24 fw-bold mt-2">{rejP}%</div>
                                                </div>
                                              </div>
                                            </Col>
                                            <Col md={4}>
                                              <div className="card mb-0">
                                                <div className="card-body">
                                                  <span className="fs-12 fw-semibold text-muted"><i className="ri-forbid-line me-1 align-middle"></i>Cancel</span>
                                                  <div className="fs-24 fw-bold mt-2">{cn}</div>
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                          {rj === 0 && <div className="text-muted fs-13 mt-3">Tidak ada reject pada periode & filter ini.</div>}
                                        </CardBody>
                                      </Card>

                                      <Card className="mt-3">
                                        <CardBody>
                                          <h5 className="card-title mb-1"><i className="ri-calendar-2-line me-1 align-bottom"></i>Aktivitas Harian — 3 Bulan Terakhir</h5>
                                          <p className="text-muted fs-13 mb-3">Seluruh tanggal 1–akhir bulan ditampilkan (mendatar). Tiap baris = tahapan: Booking, Berkas Lengkap, SP3K, Akad. <span className="text-danger fw-semibold">Kolom merah = Sabtu, Minggu, atau hari libur nasional</span> (arahkan kursor ke angka tanggal untuk nama liburnya).</p>
                                          {daBlocks.length === 0 && <div className="text-muted fs-13">Tidak ada data aktivitas pada periode & filter ini.</div>}
                                          {daBlocks.map(blk => (
                                            <div key={blk.M} className="mb-3">
                                              <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span className="fw-semibold">{moment(blk.M).format("MMMM YYYY")}</span>
                                                <span className="fs-11 text-muted">{blk.nDays} hari · {blk.activeDays} tanggal ada aktivitas</span>
                                              </div>
                                              <div className="table-responsive">
                                                <Table size="sm" hover className="align-middle text-center mb-0">
                                                  <thead>
                                                    <tr>
                                                      <th className="text-start" style={{ minWidth: "130px" }}>Tanggal</th>
                                                      {blk.dateKeys.map(dd => (
                                                        <th key={dd} title={blk.days[dd].title || undefined} className={blk.days[dd].red ? "text-danger" : ""} style={{ minWidth: "30px" }}>{+dd}</th>
                                                      ))}
                                                      <th className="text-center">Total</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {daRowDefs.map(def => {
                                                      let sum = 0;
                                                      return (
                                                        <tr key={def.key}>
                                                          <td className="text-start fw-semibold"><i className={`${def.icon} me-1 align-middle`}></i>{def.label}</td>
                                                          {blk.dateKeys.map(dd => {
                                                            const n = blk.days[dd][def.key];
                                                            sum += n;
                                                            return (
                                                              <td key={dd} className={blk.days[dd].red ? "text-danger" : ""}>{n || "·"}</td>
                                                            );
                                                          })}
                                                          <td className="fw-bold">{sum}</td>
                                                        </tr>
                                                      );
                                                    })}
                                                  </tbody>
                                                </Table>
                                              </div>
                                            </div>
                                          ))}
                                        </CardBody>
                                      </Card>
                                    </div>
                                  );
                                })()}
                              </CardBody>
                            </Card>
                          </>
                        );
                      })()}
                    </TabPane>
                  </TabContent>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    Analisa Penjualan {info?.name}
                  </ModalHeader>
                  <ModalBody>
                    <CardBody className="pb-3">
                      <div className="d-flex align-items-center mb-3">
                        <div className="flex-grow-1">
                          <input className="search-box form-control" style={{ maxWidth: "320px" }} placeholder="Filter Transaksi" onChange={(e) => searchList(e.target.value)} />
                        </div>
                      </div>
                      <div>
                        <SimpleBar style={{ height: "520px" }}>
                          <Table className="table-border text-center table-nowrap align-middle mb-0" style={{ position: "relative" }}>
                            <thead className="align-middle" style={{ position: "sticky", top: "0px", zIndex: "1", backgroundColor: "#FFFFFF" }}>
                              <tr className="bg-soft-info">
                                {/* <td style={{ width: "20px" }}>
                                  <input
                                    type="checkbox"
                                    className="checkboxDetailAll me-2 form-check-input"
                                    checked={expense.every((item) => item.isChecked)}
                                    onChange={() => {
                                      const allChecked = expense.every((item) => item.isChecked);
                                      const updatedData = expense.map((item) => {
                                        return {
                                          ...item,
                                          isChecked: !allChecked,
                                        };
                                      });
                                      setExpense(updatedData);
                                    }}
                                  />
                                </td> */}
                                <td className="text-center">No</td>
                                <td className="text-start">Kontak / Pelanggan</td>
                                <td style={{ width: "40px" }}></td>
                                <td className="text-center" style={{ width: "120px" }}>
                                  No Transaksi
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Tgl Booking
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Tgl Kantor
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Lead Time Berkas
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Tgl Bank
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Tgl SP3K
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Tgl Akad
                                </td>
                                <td className="text-center">Keterangan</td>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(expense || []).filter(f => filterDate?.split(" to ") ? isDateBetween(handleValidDate(f?.transactionat, "YYYY/MM/DD"), filterDate?.split(" to ")[0], (filterDate?.split(" to ")[1] ? filterDate?.split(" to ")[1] : filterDate?.split(" to ")[0])) : true)
                                .sort((a, b) => new Date(a.transactionat) - new Date(b.transactionat))
                                .map((o, i) => {
                                  let stat;
                                  let statDeal;
                                  let statName = o.sales_status && o.sales_status.name;
                                  let statDealId = o.sales_deal_status && o.sales_deal_status.id;
                                  switch (statName) {
                                    case "DRAFT":
                                      stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
                                      break;
                                    case "PENDING":
                                      stat = <span className="badge text-uppercase badge-soft-secondary">{statName}</span>;
                                      break;
                                    case "CONFIRMED":
                                      stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
                                      break;
                                    case "PROCESSED":
                                      stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
                                      break;
                                    case "SHIPPED":
                                      stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
                                      break;
                                    case "COMPLETED":
                                      stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
                                      break;
                                    default:
                                      stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
                                      break;
                                  }

                                  switch (statDealId) {
                                    case 3:
                                      statDeal =
                                        o.typeId === 3 || o.typeId === 4 ? (
                                          <span className="badge text-uppercase" style={{ background: "#CFECF7", color: "#20A7DB" }}>
                                            CASH
                                          </span>
                                        ) : (
                                          <span className="badge text-uppercase" style={{ background: "#ffe7ff", color: "#ea33f7" }}>
                                            {o.sales_deal_status.name}
                                          </span>
                                        );
                                      break;
                                    case 4:
                                      statDeal = (
                                        <span className="badge text-uppercase" style={{ background: "#ede3c5", color: "#806b29" }}>
                                          {o.sales_deal_status.name}
                                        </span>
                                      );
                                      break;
                                    case 5:
                                      statDeal = (
                                        <span className="badge text-uppercase" style={{ background: "#EAFAEA", color: "#65B741" }}>
                                          {o.sales_deal_status.name}
                                        </span>
                                      );
                                      break;
                                    case 6:
                                      statDeal = (
                                        <span className="badge text-uppercase" style={{ background: "#FFFBCA", color: "#F09319" }}>
                                          {o.sales_deal_status.name}
                                        </span>
                                      );
                                      break;
                                    case 7:
                                      statDeal = <span className="badge text-uppercase badge-soft-info">{o.sales_deal_status.name}</span>;
                                      break;
                                    case 8:
                                      statDeal = (
                                        <span className="badge text-uppercase" style={{ background: "#E8F9FF", color: "#2cc2c4" }}>
                                          {o.sales_deal_status.name}
                                        </span>
                                      );
                                      break;
                                    default:
                                      statDeal = "";
                                      break;
                                  }

                                  let statBank;
                                  let statBankId = o?.sales_bank_status && o?.sales_bank_status.id;
                                  switch (statBankId) {
                                    case 1:
                                      statBank = <span className="badge text-uppercase badge-soft-success">{o?.sales_bank_status.name}</span>;
                                      break;
                                    case 2:
                                      statBank = <span className="badge text-uppercase badge-soft-warning">{o?.sales_bank_status.name}</span>;
                                      break;
                                    case 3:
                                      statBank = <span className="badge text-uppercase badge-soft-danger">{o?.sales_bank_status.name}</span>;
                                      break;
                                    default:
                                      statBank = "";
                                      break;
                                  }

                                  const berkasPlaced = moment(o.transactionat);
                                  const orderCompleted = moment(o.docat);
                                  const durationBerkas = orderCompleted.diff(berkasPlaced);
                                  const leadTimeBerkas = moment.duration(durationBerkas);
                                  let startat = "";
                                  let endat = "";
                                  let datearr = filterDate?.split(" to ");
                                  if (datearr) {
                                    startat = datearr[0];
                                    endat = datearr[1] ? datearr[1] : datearr[0];
                                  }
                                  return (
                                    <Fragment key={i}>
                                      <tr className="product bg-light">
                                        <td className="text-center">{i + 1}</td>
                                        {/* <td className="product-id">
                                          <input
                                            type="checkbox"
                                            className={o.transaction_no && o.transaction_no !== "" ? "checkboxDetail ms-2 me-2 form-check-input" : "d-none"}
                                            checked={o.isChecked}
                                            onChange={() => {
                                              const updatedData = expense.map((d) => {
                                                return d.id === o.id ? { ...d, isChecked: !d.isChecked } : d;
                                              });

                                              setExpense(updatedData);
                                            }}
                                          />{" "}
                                          {i + 1}
                                        </td> */}
                                        <td><div className="text-start fw-semibold">{o?.sales_customer?.name}</div></td>
                                        <td className="text-start fw-semibold">{o?.sales_branch?.name}
                                          <div className="hstack gap-2">{stat} {statDeal} {statBank}</div>
                                        </td>
                                        <td className="text-center">{o.transaction_no}</td>
                                        <td className="text-center">{handleValidDate(o.transactionat)}</td>
                                        <td className="text-center">{handleValidDate(o.docat)}</td>
                                        <td className={leadTimeBerkas.days() > 7 && o.docat ? "text-start fw-semibold text-danger" : "text-start fw-semibold text-success"}>{o.docat ? `${leadTimeBerkas.days()} Hari, ${leadTimeBerkas.hours()} Jam, ${leadTimeBerkas.minutes()} Menit` : `-`}</td>
                                        <td className="text-center">{handleValidDate(o.bankat)}</td>
                                        <td className="text-center">{handleValidDate(o.sp3at)}</td>
                                        <td className="text-center">{handleValidDate(o.completedat)}</td>
                                        <td className="text-start">{o.description} {o.description_bank}</td>
                                      </tr>

                                    </Fragment>
                                  );
                                })}
                              {expense.length === 0 && (
                                <tr>
                                  <td colSpan="11" className="p-3 text-center">
                                    Belum ada data
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </SimpleBar>
                      </div>
                    </CardBody>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModal(false);
                        }}
                      >
                        Tutup
                      </button>
                    </div>
                  </div>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Agent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Agent));
